/**
 * 检测第三方账号是否已经绑定过
 */
import PbAjax from '../../../lib/pbajax';
import url from 'c-url';
import publicpb from '../../../base/public.pb';
import checkPb from './check.pb';

let pbajax = new PbAjax();

class ThirdCheck {

    constructor(data = {}) {
        this.promise = this.check(data);
    }

    check(data) {
        let defer = $.Deferred();
        const { Request, Response } = checkPb.ThirdParty.Check;

        let businessData = new Request(data);
        
        let requestData = {
            service: 'service',
            api: '/third/party/check'
        }

        pbajax.do(
            requestData,
            businessData,
            function(res) {
                let dataWrap = publicpb.Result.decode(res);
                let data;
                
                if (dataWrap.code == '256') { // 已绑定过
                    defer.resolve(true);
                } else if(dataWrap.code == 1) { // 未绑定过
                    defer.resolve(false);
                } else {
                    defer.reject();
                }
            },
            () => {
                defer.reject();
            },
            () => {
                defer.reject();
            });
        return defer.promise();
    }
}

export default ThirdCheck;


// WEBPACK FOOTER //
// ./js/component/thirdparty-login/thirdparty/check.js